const isInternationalType = (field: string) => field === "International";

export default isInternationalType;
